import { defineStore } from "pinia";

/** Plan selectable in the upgrade modal / pricing section. */
export type PricingPlan = "pro" | "lifetime";

export type ProModalType = "subscription" | "payPerUse" | "lifetime";

export type ProModalOptions = {
  /** Feature that led the user here, for funnel tracking. */
  feature?: string;
  /** Credits the user is short of; presets the pay-per-use amount. */
  shortfall?: number;
};

interface ProModalStore {
  isOpen: boolean;
  modalType: ProModalType;
  feature: string | null;
  shortfall: number | null;
}

export const useProModal = defineStore("proModal", {
  state: (): ProModalStore => ({
    isOpen: false,
    modalType: "subscription",
    feature: null,
    shortfall: null,
  }),
  actions: {
    onOpen(type: ProModalType = "subscription", opts: ProModalOptions = {}) {
      this.modalType = type;
      // Keep the originating feature when switching mode inside an open modal.
      this.feature = opts.feature ?? (this.isOpen ? this.feature : null);
      this.shortfall =
        opts.shortfall && opts.shortfall > 0 ? Math.ceil(opts.shortfall) : null;
      this.isOpen = true;
    },
    onClose() {
      this.isOpen = false;
      this.feature = null;
      this.shortfall = null;
    },
  },
});
